import { useContext, createContext } from 'react';
import { decomposeJson } from '../decomposeJson';
import { DecomposeMethod } from '../types';

export type TreeViewState = {
  collapseByDefault: boolean;
  highlight?: string;
  sort: boolean;
  tableColor?: string;
  altRowColorDepth?: number;
  showBranchFocus?: boolean;
  isNestedTable?: boolean;
  decompose: DecomposeMethod;
};

export const TreeViewContext = createContext<TreeViewState>({
  collapseByDefault: false,
  sort: false,
  decompose: decomposeJson as DecomposeMethod,
});

export const useTreeViewContext = () => useContext(TreeViewContext);
